import { render, staticRenderFns } from "./sendSmsRecord.vue?vue&type=template&id=d886821c&scoped=true&"
import script from "./sendSmsRecord.vue?vue&type=script&lang=js&"
export * from "./sendSmsRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d886821c",
  null
  
)

component.options.__file = "sendSmsRecord.vue"
export default component.exports